module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.getters.appDeviceType != 'Phone') ? _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Lead Conversion Trend")]), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "line",
      "height": "350",
      "options": _vm.lineChartOptions,
      "series": _vm.lineChartSeries
    }
  })], 1)])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Revenue by Month")]), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.barChartOptions,
      "series": _vm.barChartSeries
    }
  })], 1)])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Lead Status Distribution")]), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "pie",
      "height": "350",
      "options": _vm.pieChartOptions,
      "series": _vm.pieChartSeries
    }
  })], 1)])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Performance by Client")]), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "350",
      "options": _vm.donutChartOptions,
      "series": _vm.donutChartSeries
    }
  })], 1)])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-141ffaa9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/ChartsSection.vue
// module id = 2407
// module chunks = 0